
const FORM = 'Form';
const MESSAGE = 'Message'
const TABLE = 'Table';

export { FORM, MESSAGE, TABLE }